var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{attrs:{"id":"aside"}},[_c('ul',_vm._l((_vm.navList),function(ref){
var tag_id = ref.tag_id;
var tag_icon = ref.tag_icon;
var tag_name = ref.tag_name;
return _c('li',{key:tag_id,staticClass:"active"},[_c('p',{on:{"click":function($event){return _vm.$router.push(("/tag/" + tag_name + "/" + tag_id))}}},[_c('img',{staticClass:"icon",attrs:{"src":tag_icon}}),_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(tag_name))])])])}),0),_c('a',{staticClass:"tweet",attrs:{"href":"javascript:void(0)"}},[_vm._v("Tweet")])])}
var staticRenderFns = []

export { render, staticRenderFns }